import { useForm } from "react-hook-form";
import { useAppDispatch, useAppSelector } from "../../../../hooks";
import {
  getInstanceAsync,
  handleToggleInstanceColdModal,
  rebootInstanceAsync,
  selectInstance,
  selectInstanceLoading,
  selectShowColdModal,
} from "../../../../store/instances/instanceSlice";
import { getInstancesAsync } from "../../../../store/instances/instancesSlice";
import { Button, Modal, Typography } from "djuno-design";
import { useCallback, useEffect } from "react";

const InstanceColdRebootModal = () => {
  const dispatch = useAppDispatch();
  const isOpen = useAppSelector(selectShowColdModal);
  const loading = useAppSelector(selectInstanceLoading);
  const instance = useAppSelector(selectInstance);

  const {
    handleSubmit,
    reset,
    formState: { errors, isValid },
  } = useForm({
    shouldUnregister: true,
    reValidateMode: "onChange",
  });

  const onSubmit = (data: any) => {
    if (instance) {
      const formData = {
        type: "hard",
      };
      dispatch(
        rebootInstanceAsync({ instanceId: instance?.id, data: formData })
      ).then((action) => {
        if (action.type === "instance/reboot/fulfilled") {
          dispatch(getInstancesAsync({ withoutLoading: false }));
          dispatch(getInstanceAsync({ instanceId: instance.id }));
          handleOnClose();
        }
      });
    }
  };

  const handleOnClose = useCallback(() => {
    reset();
    dispatch(handleToggleInstanceColdModal(false));
  }, [dispatch, reset]);

  useEffect(() => {
    return () => {
      handleOnClose();
    };
  }, [handleOnClose]);

  return (
    <Modal
      isOpen={isOpen}
      onClose={handleOnClose}
      contentClassName="max-w-lg"
      //containerClassName="!items-start"
      title="Cold reboot (hard)"
    >
      <form onSubmit={handleSubmit(onSubmit)}>
        <div className="my-5">
          <Typography.Text className="!text-sm">
            You are about to reboot your {instance?.name} instance.
          </Typography.Text>
        </div>

        <div className="mt-4 flex justify-end gap-2">
          <Button uiType="light" onClick={handleOnClose}>
            Cancel
          </Button>
          <Button
            uiType="primary"
            disabled={!isValid}
            type="submit"
            loading={loading}
          >
            Confirm
          </Button>
        </div>
      </form>
    </Modal>
  );
};

export default InstanceColdRebootModal;
